define('Categories.Segmentation', [
    'SC.Configuration',
	'underscore'
], function (
    Configuration,
	_
) {
    'use strict';
    
	return  {
        makeNavigationTabWithSegmentation: function (categories, isB2B){
            var self = this,
                result = [];
            _.each(categories, function (category){
                var tab = category;
                var willPushTab = false  ;
                if(isB2B){
                    if(category.additionalFields && (category.additionalFields.custrecord_ano_cc_segmentation == 1 || category.additionalFields.custrecord_ano_cc_segmentation == 2)){
                        willPushTab = true;
                    }
                } else {
                    if(category.additionalFields && (category.additionalFields.custrecord_ano_cc_segmentation == 1 || category.additionalFields.custrecord_ano_cc_segmentation == 3)){
                        willPushTab = true;
                    }
                }

                if (category.categories)
				{
					tab.categories = self.makeNavigationTabWithSegmentation(category.categories, isB2B);
                }

                //If not a tab from category, we push it to the new navigationData
                if(willPushTab || !category.additionalFields){
                    result.push(tab);
                }

            });
            return result;
		},
		
		loadModule: function loadModule(container) {
            // var self = this;
            // var userProfileComponent = container.getComponent('UserProfile');
            // var plp = container.getComponent("PLP");
            // var isB2B = false;
            // _.defer(function() {
            //     userProfileComponent.getUserProfile().then(function(profile) {
            //         isB2B = profile.isloggedin ? _.findWhere(profile.customfields, {id: 'custentity_ano_is_b2b'}).value:false;
            //         // console.log('catetgs isB2B', isB2B);
            //
            //         console.log('Configuration.get(categories)', Configuration.get('categories'))
            //
            //         if (Configuration.get('categories') && Configuration.get('navigationData')){
            //             var navigationData = Configuration.get('navigationData');
            //             // console.log('navigationData', navigationData);
            //             navigationData = self.makeNavigationTabWithSegmentation(navigationData, isB2B);
            //             Configuration.navigationData = navigationData;
            //             container.trigger('Configuration.navigationData');
            //         }
            //     });
            //
            // });
            //
            //
            // if(plp){
            //     plp.on('beforeShowContent', function (){
            //         var current_view = plp.current_view;
            //         var current_model = plp.current_view.model;
            //         var categoryModel = current_model.get('category');
            //         var categories = categoryModel && categoryModel.get('categories');
            //
            //         console.log('CATEGORIES', categories)
            //
            //         var siblings = categoryModel && categoryModel.get('siblings');
            //         var view = plp.viewToBeRendered;
            //         view.on('afterViewRender', function afterViewRender() {
            //             if(categoryModel) {
            //                 var segmentation = categoryModel.get('custrecord_ano_cc_segmentation');
            //
            //                 console.log('segmentation', segmentation)
            //
            //                 var customerSegmentation = isB2B ? 2 : 3;
            //
            //             if(segmentation == 1 || segmentation == customerSegmentation) {
            //                 categories = _.reject(categories, function (category){
            //                     return category.custrecord_ano_cc_segmentation != 1 && category.custrecord_ano_cc_segmentation != customerSegmentation;
            //                 });
            //                 if(siblings){
            //                     siblings = _.reject(siblings, function (sibling){
            //                         return sibling.custrecord_ano_cc_segmentation != 1 && sibling.custrecord_ano_cc_segmentation != customerSegmentation;
            //                     });
            //                     categoryModel.set('siblings', siblings);
            //                 }
            //                 categoryModel.set('categories', categories);
            //             } else {
            //                 // current_model.set('category', []);
            //             }
            //             // current_view.renderChild('Facets.CategorySidebar');
            //             }
            //         });
            //     });
            //
            // }
        }
    };
});
